import type { ITheme } from "@fluentui/react/lib/Styling";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { AppColors, IContextualMenuClassNames } from "@1js/acui-common";
import { getContextualMenuClassNames } from "@1js/acui-common";

export const getOverflowMenuClassNames = memoizeFunction(
  (appColors?: AppColors): ((theme: ITheme) => IContextualMenuClassNames) => {
    return (theme: ITheme): IContextualMenuClassNames => {
      return mergeStyleSets(getContextualMenuClassNames(theme, appColors), {
        root: {
          minWidth: 82,
        },
      }) as IContextualMenuClassNames;
    };
  }
);
